import React from "react";
import { AvailableTransferMaterial } from "../../../../models/materialStockTransfer.model";
import {
  convertMaterialQuantity,
  getMaterialDisplayUnit,
} from "./materialTransfer.utils";

interface MaterialTransferItemEditorProps {
  material: AvailableTransferMaterial | null;
  quantity: string;
  onQuantityChange: (value: string) => void;
  serialNumbers: string;
  onSerialNumbersChange: (value: string) => void;
  senderRemark: string;
  onSenderRemarkChange: (value: string) => void;
}

const MaterialTransferItemEditor: React.FC<MaterialTransferItemEditorProps> = ({
  material,
  quantity,
  onQuantityChange,
  serialNumbers,
  onSerialNumbersChange,
  senderRemark,
  onSenderRemarkChange,
}) => {
  if (!material) return null;

  const displayUnit = getMaterialDisplayUnit(material.unit);
  const availableQuantity =
    convertMaterialQuantity(material.quantity, material.unit, displayUnit) ??
    material.quantity;

  return (
    <div className="mt-4 grid gap-4 rounded-xl border border-gray-200 bg-gray-50 p-4 sm:grid-cols-2">
      <label className="block text-sm font-medium text-gray-700">
        Quantity ({displayUnit}) *
        <input
          type="number"
          min="0"
          step={material.requireSerialNumber ? 1 : "any"}
          max={availableQuantity}
          inputMode="decimal"
          value={quantity}
          onChange={(event) => onQuantityChange(event.target.value)}
          className="mt-1 min-h-11 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-[#0077C0] focus:outline-none focus:ring-2 focus:ring-blue-100"
        />
        <span className="mt-1 block text-xs font-normal text-gray-500">
          Available:{" "}
          {availableQuantity.toLocaleString(undefined, {
            maximumFractionDigits: 4,
          })}{" "}
          {displayUnit}
        </span>
      </label>

      {material.requireSerialNumber && (
        <label className="block text-sm font-medium text-gray-700 sm:col-span-2">
          Serial numbers *
          <textarea
            value={serialNumbers}
            onChange={(event) => onSerialNumbersChange(event.target.value)}
            placeholder="Enter one serial number per line"
            rows={3}
            className="mt-1 min-h-24 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-[#0077C0] focus:outline-none focus:ring-2 focus:ring-blue-100"
          />
          <span className="mt-1 block text-xs font-normal text-gray-500">
            Enter unique serial numbers separated by new lines or commas.
          </span>
        </label>
      )}

      <label className="block text-sm font-medium text-gray-700 sm:col-span-2">
        Sender remark
        <input
          value={senderRemark}
          onChange={(event) => onSenderRemarkChange(event.target.value)}
          placeholder="Optional remark"
          className="mt-1 min-h-11 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-[#0077C0] focus:outline-none focus:ring-2 focus:ring-blue-100"
        />
      </label>
    </div>
  );
};

export default MaterialTransferItemEditor;
